import { Box } from '@mui/material';
import { useEffect } from 'react';

import { ResizeHandle, useResizeHandle } from '../workspace-common/components';
import {
    DEFAULT_LEFT_SIDEBAR_WIDTH,
    DEFAULT_RIGHT_SIDEBAR_WIDTH,
} from '../workspace-common/constants';
import { AnnotationConfig } from './components/AnnotationConfig/AnnotationConfig';
import { AnnotationContent } from './components/AnnotationContent/AnnotationContent';
import { NoteListSidebar } from './components/NoteListSidebar/NoteListSidebar';
import { useAnnotationScreen } from './useAnnotationScreen';

export const AnnotationScreen = () => {
  const { annotationStarted } = useAnnotationScreen();

  const {
    startRightResize,
    startLeftResize,
    setRightInitialWidthToDefault,
    rightWidth,
    leftWidth,
  } = useResizeHandle({
    initialLeftWidth: DEFAULT_LEFT_SIDEBAR_WIDTH,
    initialRightWidth: DEFAULT_RIGHT_SIDEBAR_WIDTH,
  });

  useEffect(() => {
    setRightInitialWidthToDefault();
  }, [annotationStarted]);

  return (
    <Box sx={{ display: 'flex' }}>
      <NoteListSidebar leftWidth={leftWidth} />
      <ResizeHandle onMouseDown={(e: React.MouseEvent) => startLeftResize(e)} />
      <AnnotationContent />
      {annotationStarted && (
        <ResizeHandle onMouseDown={(e: React.MouseEvent) => startRightResize(e)} />
      )}
      <AnnotationConfig rightWidth={rightWidth} />
    </Box>
  );
};
